import { LOGOUT } from '../auth/actions';
import {
    CHANGE_PASSWORD_FAILED,
    CHANGE_PASSWORD_FIELD_CHANGED,
    CHANGE_PASSWORD_FORM_CLEAR_REQUESTED,
    CHANGE_PASSWORD_REQUESTED,
    CHANGE_PASSWORD_SUCCEEDED,
} from './actions';
import { update } from '../../utils/immutable';
import { omit } from '../../utils';

const initialDataState = {
    oldPassword: '',
    newPassword: '',
    newPasswordConfirmation: '',
};

const initialState = {
    saving: false,
    data: initialDataState,
    formErrors: [],
    formSuccessMessages: [],
    fieldErrors: {},
};

export default (state = initialState, { type, ...payload }) => {
    switch (type) {
        case CHANGE_PASSWORD_REQUESTED:
            return update(state, {
                saving: true,
                formErrors: [],
                formSuccessMessages: [],
                fieldErrors: {},
            });
        case CHANGE_PASSWORD_SUCCEEDED:
            return update(state, {
                saving: false,
                data: initialDataState,
                formErrors: [],
                formSuccessMessages: ['Successfully changed your password!'],
                fieldErrors: {},
            });
        case CHANGE_PASSWORD_FAILED:
            return update(state, {
                saving: false,
                formErrors: [],
                formSuccessMessages: [],
                fieldErrors: payload.fieldErrors,
            });
        case CHANGE_PASSWORD_FIELD_CHANGED:
            return update(state, {
                data: update(state.data, {
                    [payload.field]: payload.value,
                }),
                fieldErrors: omit(state.fieldErrors, [payload.field]),
            });
        case CHANGE_PASSWORD_FORM_CLEAR_REQUESTED: // Intentional fallthrough
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
};
